import React from 'react';
import { Modal, Input } from 'antd';
import { PC } from './PC';
import { DHCPServer } from './DHCPServer';
import { Router } from './Router';
import { Modem } from './Modem';
import { AP } from './AP';
import { MobileDevice } from './MobileDevice'
import { HomeGateway } from './HomeGateway';
import SmartBulb from './IOT/SmartBulb';
import SmartSpeaker from './IOT/SmartSpeaker';
import SmartLock from './IOT/SmartLock';
import SmartBell from './IOT/SmartBell';
import Firewall from './Firewall';

const deviceTypeDetailMap = {
  'Switch': null,
  'PC': PC,
  'DHCPServer': DHCPServer,
  'Router': Router,
  'Modem': Modem,
  'AP': AP,
  'MobileDevice': MobileDevice,
  'HomeGateway': HomeGateway,
  'SmartBulb': SmartBulb,
  'SmartSpeaker': SmartSpeaker,
  'SmartLock': SmartLock,
  'SmartBell': SmartBell,
  'Firewall': Firewall,
}

const DeviceModal = (props) => {
  let { node, device, onClose, isAdmin } = props;

  const Detail = deviceTypeDetailMap[device.deviceType];
  return (
    <div className="deviceModal">
        <Modal
          title={<div style={{width:'30vw'}}><Input defaultValue={node.attrs.text.text} onBlur={(e) => {
            node.setAttrs({text: { text: e.target.value }});
          }} /></div>}
          visible={true}
          onCancel={onClose}
          width={'70vw'}
          height={'50vh'}
          footer = {null}
        >
          { Detail ? <Detail node={node} device={device} isAdmin={isAdmin} onClose={onClose} />: '该设备没有其他可配置项' }
        </Modal>
    </div>
  );
};

export default DeviceModal;
